module.exports = __webpack_public_path__ + "img/bi_spinner.55d8b5fa.svg";